module.exports = __webpack_public_path__ + "static/media/lentz_frank.a3997a93.jpg";